module.exports = __webpack_public_path__ + "img/logo.30b66f5b.svg";